var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { COLLECT_MAX_FILE_SIZE_MB, COLLECT_UPLOAD_ACCEPT, } from "./collect.constants";
var DEFAULT_COLLECT_RULES = {
    fileLimit: { mode: "fixed", files: 3 },
};
var COLLECT_RULES_BY_SUBDOMAIN = {
    "acap-subdomain": { fileLimit: { mode: "fixed", files: 2 } },
};
export var getCollectRulesConfig = function () {
    var _a, _b;
    var subdomain = (_a = findParamInLocalStorage("subdomain")) !== null && _a !== void 0 ? _a : "";
    return __assign(__assign({}, DEFAULT_COLLECT_RULES), ((_b = COLLECT_RULES_BY_SUBDOMAIN[subdomain]) !== null && _b !== void 0 ? _b : {}));
};
export var resolveMaxFiles = function (rules, context) {
    var _a;
    if (rules.fileLimit.mode === "perProduct") {
        return Math.max(1, context.productCount + ((_a = rules.fileLimit.extraFiles) !== null && _a !== void 0 ? _a : 0));
    }
    return rules.fileLimit.files;
};
export var hasAllowedExtension = function (fileName) {
    var lower = fileName.toLowerCase();
    return COLLECT_UPLOAD_ACCEPT.some(function (extension) { return lower.endsWith(extension); });
};
export var isWithinSizeLimit = function (sizeBytes) {
    return sizeBytes <= COLLECT_MAX_FILE_SIZE_MB * 1024 * 1024;
};
